import ApiService from '@/store/ApiService.js'

const favoriteListModule = {
  state: {
    favoriteList: [],
    containFlag: false
  },
  mutations: {
    updateFavoriteList (state, playList) {
      if (typeof playList === 'object') {
        let index = 0
        let result = []
        Object.keys(playList).map(function (key) {
          result[index] = playList[key]
          index = index + 1
        })
        playList = result
      }
      state.favoriteList = playList
      return true
    },
    updateContainFlag (state, boolean) {
      state.containFlag = boolean
    }
  },
  actions: {
    favoriteListModuleSetPlayList (context, playList) {
      this.commit('updateFavoriteList', playList)
    },
    async favoriteListModuleSetContainFlag (context, boolean) {
      await this.commit('updateContainFlag', boolean)
    },
    async apiGetFavoriteList (context, transactionId) {
      let targetPath = 'ajax/favorite.php' + '?transactionid=' + transactionId
      let response = await ApiService.get(targetPath)
      await this.commit('updateFavoriteList', response.data)
    },
    isContainFavoriteList (context, productId) {
      let result = false
      for (let index in context.state.favoriteList) {
        let favorite = context.state.favoriteList[index]
        if (parseInt(productId) === parseInt(favorite.product_id)) {
          result = true
        }
      }
      this.commit('updateContainFlag', result)
      return result
    }
  },
  getters: {
    getFavoriteList (state) {
      return state.favoriteList
    },
    getContainFlag (state) {
      return state.containFlag
    }
  }
}
export default favoriteListModule



// WEBPACK FOOTER //
// ./src/store/FavoriteListModule.js